// libs
import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
// components
import { Checkbox, Stack } from '@lyearn/ui';
import { ContextualUserGroupType } from '@/components/Form/components/VisibilitySettings/types';
import { VisibilitySettingsRestrictionTypeEnum } from '@/types/schema';

import { ContentCollectionFragment } from '../../views/GroupManager/graphql/fragments/generated/ContentCollection';
import { UserCollectionFragment } from '../../views/GroupManager/graphql/fragments/generated/UserCollection';
import GroupTab from '../GroupTab';

interface ListItemProps {
  group: UserCollectionFragment | ContentCollectionFragment | ContextualUserGroupType;
  selected?: boolean;
  onSelect: (groupId: string, contextualGroupId?: VisibilitySettingsRestrictionTypeEnum) => void;
  disabled?: boolean;
  classes?: { container?: string };
}

function ListItem(props: ListItemProps) {
  const { group, onSelect, selected, disabled, classes } = props;
  const isAutoSyncGroup = 'isAutoSyncGroup' in group && !!group?.isAutoSyncGroup;

  const _onSelect = useCallback(() => {
    if (disabled) {
      return;
    }
    if (group.type === 'ContextualUserGroupType') {
      onSelect('', group.id);

      return;
    }
    onSelect(group.id);
  }, [disabled, group.type, group.id, onSelect]);

  return (
    <Stack
      alignItems="center"
      className={cn(
        'flex-shrink-0 border-b border-divider py-16 ps-16 pe-20 group/assign',
        classes?.container,
      )}
      justifyContent="between"
      role="button"
      onClick={_onSelect}>
      <GroupTab group={group} showAutoSync={isAutoSyncGroup} />
      <Checkbox checked={selected} disabled={disabled} />
    </Stack>
  );
}

export default ListItem;
